{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-21T22:03:50.622Z","source":"place-details"}